export const colors = {
  green: "#33cc99",
  hoverGreen: "#2db88a",
  disabledGreen: "#aeecd7",
  yellow: "#fdcd26",
  hoverYellow: "#e9bc21",
  black: "#484848",
  grey: "#a0a0a0",
  border: "#dfdfdf",
  disabledGrey: "#efefef",
  error: "#f15252"
};

export const API_ROOT = "/api/web/vdev/";

export function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function parseJSON(response) {
  return response.json();
}



// WEBPACK FOOTER //
// ./src/util/constants.js